import getValidator, { isEmpty, Validation, ValidationResult } from './getValidator';

export type ZipCodeValidation = Validation & {
  allowList?: string[];
  blockList?: string[];
};

const getZipCodeValidator =
  ({ allowList, blockList, ...defaultValidation }: Omit<ZipCodeValidation, 'maxLength'>) =>
  (value: string): ValidationResult => {
    const defaultValidationResult = getValidator(defaultValidation)(value);
    if (defaultValidationResult) {
      return defaultValidationResult;
    }
    const normalizedZipCode = value.replaceAll(' ', '');
    if (!defaultValidation.required && isEmpty(normalizedZipCode)) {
      return undefined;
    } else if (allowList && !allowList?.includes(normalizedZipCode)) {
      return { key: 'blocked' };
    } else if (blockList?.includes(normalizedZipCode)) {
      return { key: 'blocked' };
    } else {
      return undefined;
    }
  };

export default getZipCodeValidator;
